import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/Login')
const DeviceList = () => import('@/views/DeviceList')
const GeoLocationList = () => import('@/views/GeoLocationList')
const ChargerBrand = () => import('@/views/ChargerBrand')
const DeviceManager = () => import('@/views/DeviceManager')
const UserList = () => import('@/views/UserList')
const EndUserInfo = () => import('@/views/EndUserInfo')
const IpcList = () => import('@/views/IpcList')
const AdminList = () => import('@/views/AdminList')
const UnitList = () => import('@/views/UnitList')
const Device = () => import('@/views/Device')
const DeviceApplePayTest = () => import('@/views/DeviceApplePayTest')
const UserHistory = () => import('@/views/UserHistory')
const Transaction = () => import('@/views/Transaction')
const AddValues = () => import('@/views/AddValues')
const Nav = () => import('@/views/Nav')
const Company = () => import('@/views/Company')
const Coupon = () => import('@/views/Coupon')
const Role = () => import('@/views/Role')
const ApiTiming = () => import('@/views/ApiTiming')
const MeterList = () => import('@/views/MeterList')

const EndUserLogin = () => import('@/views/EndUserLogin')
const EndUserRegister = () => import('@/views/EndUserRegister')
const EndUserResetPassword = () => import('@/views/EndUserResetPassword')
const EndUserDirectCharging = () => import('@/views/EndUserDirectCharging')
const EndUserPhoneDirectCharging = () => import('@/views/EndUserPhoneDirectCharging2')

const SearchContainer = () => import('@/containers/SearchContainer')
const DeviceStatusList = () => import('@/views/DeviceStatusList')
const MembersSetting = () => import('@/views/MembersSetting')
const Maps = () => import('@/views/Maps')
const QRCodes = () => import('@/views/QRCodes')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: '登入',
      component: EndUserLogin
    },
    {
      path: '/aregg',
      name: '註冊',
      component: EndUserRegister
    },
    {
      path: '/amnesia',
      name: '忘記密碼',
      component: EndUserResetPassword
    },
    {
      path: '/dircharging',
      name: '直接充電',
      // component: EndUserDirectCharging
      component: EndUserPhoneDirectCharging,
    },
    {
      path: '/_admin_',
      name: '管理員登入',
      component: Login,
    },
    {
      path: '/search',
      name: '狀態查詢',
      component: SearchContainer,
      children: [
        {
          path: 'devices',
          name: '裝置列表',
          component: DeviceStatusList
        },
      ]
    },
    {
      path: '/dashboard',
      name: '頂層',
      component: DefaultContainer,
      children: [
        {
          path: 'home',
          name: '主控板',
          component: Dashboard
        },
        {
          path: 'bioentry',
          name: '裝置管理',
          component: DeviceManager,
        },
        {
          path: 'devices',
          name: '裝置列表',
          component: DeviceList
        },
        {
          path: 'geo-locations',
          name: '地理位置列表',
          component: GeoLocationList
        },
        {
          path: 'charger-brands',
          name: '廠牌列表',
          component: ChargerBrand
        },
        {
          path: 'manager',
          name: '裝置管理',
          component: DeviceManager,
        },
        {
          path: 'coupons',
          name: '優惠卷管理',
          component: Coupon,
        },
        {
          path: 'showdevice',
          name: '裝置',
          component: Device
        },
        {
          path: 'showdevice-applepay',
          name: '裝置 - ApplePay',
          component: DeviceApplePayTest
        },
        {
          path: 'history',
          name: '充電紀錄',
          component: UserHistory
        },
        {
          path: 'transactions',
          name: '交易紀錄',
          component: Transaction
        },
        {
          path: 'members-setting',
          name: '會員專區',
          component: MembersSetting
        },
        {
          path: 'maps',
          name: '充電地圖',
          component: Maps
        },
        {
          path: 'addvalues',
          name: '儲值紀錄',
          component: AddValues
        },
        {
          path: 'users',
          name: '使用者列表',
          component: UserList
        },
        {
          path: 'userinfo',
          name: '使用者資訊',
          component: EndUserInfo
        },
        {
          path: 'ipcs',
          name: 'IPC列表',
          component: IpcList
        },
        {
          path: 'meters',
          name: '電表列表',
          component: MeterList
        },
        {
          path: 'admins',
          name: '管理員列表',
          component: AdminList
        },
        // {
        //   path: 'apitiming',
        //   name: 'API呼叫紀錄',
        //   component: ApiTiming
        // },
        {
          path: 'units',
          name: '單位列表',
          component: UnitList
        },
        // {
        //   path: 'navs',
        //   name: '選單列表',
        //   component: Nav
        // },
        {
          path: 'companies',
          name: '公司列表',
          component: Company
        },
        // {
        //   path: 'roles',
        //   name: '角色列表',
        //   component: Role
        // },
        {
          path: 'qrcodes',
          name: 'QRCode列印',
          component: QRCodes
        },
      ]
    },
  ]
})
